// Cliente HTTP unico. Caminhos relativos: mesma origem em prod, proxy do Vite em dev.
// `credentials: same-origin` para o cookie httpOnly de sessao viajar sozinho.

export class ApiError extends Error {
  constructor(status, codigo, mensagem, detalhes) {
    super(mensagem)
    this.name = 'ApiError'
    this.status = status
    this.codigo = codigo
    this.detalhes = detalhes
  }
}

async function requisicao(metodo, caminho, corpo) {
  const resposta = await fetch(`/api${caminho}`, {
    method: metodo,
    credentials: 'same-origin',
    headers: corpo === undefined ? undefined : { 'Content-Type': 'application/json' },
    body: corpo === undefined ? undefined : JSON.stringify(corpo),
  })

  const texto = await resposta.text()
  const dados = texto ? JSON.parse(texto) : null

  if (!resposta.ok) {
    const erro = dados?.erro ?? {}
    throw new ApiError(resposta.status, erro.codigo ?? 'erro_desconhecido', erro.mensagem ?? resposta.statusText, erro.detalhes)
  }

  return dados
}

export const api = {
  get: (caminho) => requisicao('GET', caminho),
  post: (caminho, corpo) => requisicao('POST', caminho, corpo ?? {}),
  put: (caminho, corpo) => requisicao('PUT', caminho, corpo ?? {}),
  del: (caminho) => requisicao('DELETE', caminho),
}
